var parameterInsert={
    IdEnterprise:-1,   
    DivisionName:'', 
    Active:1,    
    CreateUser:'',
    IP:''
} 
var parameterUpdate={
    Active:1,
    DivisionName:'',
    IdDivision:'',
    IP:'',
    CreateUser:'',
} 

var parameterView={  
    IdEnterprise:-1,
    DivisionName:'',
    Active:1
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}